import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConstant } from 'src/app/app.constant';

@Injectable({
  providedIn: 'root'
})
export class DriversService {
  apiUrl: string;

  constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl()
  }
  manageDriver(driver) {
    return this.httpClient.post(`${this.apiUrl}/manageDriver`, driver).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  public getAllDriverName() {
    return this.httpClient.get(`${this.apiUrl}/getAllDriver/`).pipe(
        map((response: any) => {
            return response
        })
    )
}
  getDriverById(driverId) {
    return this.httpClient.get(`${this.apiUrl}/getDriverById/` + driverId).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  bulkCreateDriver(DriverData) {
    return this.httpClient.post(`${this.apiUrl}/bulkImportDriver`, DriverData).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  get() {
    return new Promise((resolve, reject) => {
      this.httpClient.get(`${this.apiUrl}/getAllDriver/`).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  bulkDeleteDriver(driverData) {
    let params = {
      DataToDelete: driverData
    }
    return this.httpClient.post(`${this.apiUrl}/bulkDeleteDriver`, params).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  public getAllDriverKendo(IsActive = true): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllDriver?IsActive=${IsActive}`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
}
